// src/components/common/SparkLayout.tsx

import React, { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SparkNav from './SparkNav';
import sparkLogo from './images/sparklogo9.png';
import sparkMoon from './images/sparkmoon2.png';
// Remove the sparkBg import since we're not using it anymore
// import sparkBg from './images/sparkbackground.png';

interface SparkLayoutProps {
  children: ReactNode;
  title?: string;
}

const SparkLayout: React.FC<SparkLayoutProps> = ({
  children,
  title = 'SPARK',
}) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Handle logout function
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div
      style={{
        // Replace background image with diagonal gradient
        background: 'linear-gradient(135deg, #0E0CAB 0%, #B81D81 100%)',
        overflowY: 'auto',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {/* Glass overlay for better contrast */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(11, 0, 80, 0.3)',
          backdropFilter: 'blur(1px)',
          zIndex: 0,
        }}
      />

      {/* Header */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          minHeight: '100px',
          marginTop: '10px',
          zIndex: 1,
        }}
      >
        {/* Centered moon + logo */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none', // keeps clicks going to Nav
          }}
        >
          {/* Moon (2× size) */}
          <img
            src={sparkMoon}
            alt="Moon"
            style={{
              width: '240px',
              height: '240px',
              objectFit: 'contain',
              filter: 'drop-shadow(0 0 12px rgba(255,255,255,.4))',
            }}
          />
          {/* Logo overlaid */}
          <img
            src={sparkLogo}
            alt={title}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxHeight: '80px',
              width: 'auto',
            }}
          />
        </div>

        {/* Navigation */}
        <SparkNav onLogout={handleLogout} />
      </div>

      {/* Optional spacing before main content */}
      <div style={{ height: '20px', position: 'relative', zIndex: 1 }} />

      {/* MAIN CONTENT (stacked & centered) */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default SparkLayout;